const AsyncActionStatus = {
  PENDING: Symbol('pending'),
  FULFILLED: Symbol('fulfilled'),
  REJECTED: Symbol('rejected'),
};

export default AsyncActionStatus;
